import { render, staticRenderFns } from "./home-header.vue?vue&type=template&id=2578e3a9&lang=pug&"
import script from "./home-header.vue?vue&type=script&lang=js&"
export * from "./home-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports